import React from "react";
import { Shirt, Pencil, PackageCheck } from "lucide-react";
import { buildWhatsAppLink } from "../constants";

const steps = [
  {
    n: "01",
    icon: Shirt,
    title: "Elige tu prenda",
    desc: "Body, jersey, sudadera, conjunto deportivo… te asesoramos según tu necesidad.",
  },
  {
    n: "02",
    icon: Pencil,
    title: "Personalízala",
    desc: "Nombre, logo, número o frase. Tú decides.",
  },
  {
    n: "03",
    icon: PackageCheck,
    title: "Recíbela",
    desc: "La confeccionamos con cariño y la enviamos a tu casa, lista para estrenar.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="como-funciona"
      data-testid="how-it-works-section"
      className="relative py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <div className="max-w-2xl mb-16 sm:mb-20">
          <div className="label-eyebrow mb-4">Cómo funciona</div>
          <h2
            data-testid="how-it-works-title"
            className="font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink leading-[1.05]"
          >
            Tres pasos para
            <br />
            tu prenda <span className="italic text-vino">soñada</span>.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 lg:gap-2 relative">
          {/* Connecting dotted line */}
          <div className="hidden md:block absolute top-16 left-[16%] right-[16%] h-px border-t border-dashed border-gold/40" />

          {steps.map((s, idx) => {
            const Icon = s.icon;
            return (
              <div
                key={s.n}
                data-testid={`step-${s.n}`}
                className="relative flex flex-col items-start lg:items-center text-left lg:text-center px-2 lg:px-6"
              >
                <div className="relative z-10 mb-6">
                  <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-page border border-line flex items-center justify-center shadow-[0_18px_40px_-15px_rgba(114,47,55,0.25)]">
                    <Icon className="text-vino" size={28} />
                  </div>
                  <span className="absolute -top-3 -right-3 font-heading text-[64px] leading-none text-cream -z-0">
                    {s.n}
                  </span>
                </div>
                <h3 className="font-heading text-2xl sm:text-3xl text-ink mb-3">
                  {s.title}
                </h3>
                <p className="text-[15px] text-ink-soft leading-relaxed max-w-xs">
                  {s.desc}
                </p>
                {idx < steps.length - 1 && (
                  <span className="md:hidden mt-6 text-gold text-2xl">↓</span>
                )}
              </div>
            );
          })}
        </div>

        <div className="mt-16 sm:mt-20 text-center">
          <a
            href={buildWhatsAppLink("Hola, quiero comenzar mi pedido.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="how-it-works-cta"
            className="inline-flex items-center gap-2 rounded-full bg-vino text-page px-7 py-4 text-[15px] font-medium hover:bg-vino-deep transition-all hover:-translate-y-1 shadow-[0_18px_40px_-15px_rgba(114,47,55,0.55)]"
          >
            Empezar mi pedido por WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
